import { render, staticRenderFns } from "./ItemHero.vue?vue&type=template&id=7d7e3039&"
import script from "./ItemHero.vue?vue&type=script&lang=js&"
export * from "./ItemHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports